<template>
  <v-dialog v-model="show" :max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Nueva zona</span>
        <v-btn icon dark @click="show = false" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="addUser">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="text-subtitle-1 font-weight-bold primary--text">Datos generales</span>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Nombre"
                  :rules="validation()"
                  v-model="name"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Ciudad"
                  v-model="city"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Estado"
                  v-model="state"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Codigo postal"
                  :rules="validation()"
                  type="number"
                  v-model="zipCode"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="Asesor externo en zona(s)"
                  v-model="advisor"
                  :rules="validationEmail()"
                  @keyup.enter="addAdvisor"
                  class="white rounded-lg"
                  append-icon="mdi-email-plus-outline"
                  @click:append="addAdvisor"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-chip
                  v-for="(item, index) in advisorsExternalZone"
                  :key="index"
                  @click:close="removeAdvisor(index)"
                  close
                >
                  {{ item }}
                </v-chip>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="show = false"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          rounded
          @click="addZone"
          :loading="isLoading"
          elevation="0"
          class="px-8"
        >
          Crear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import {
  requiredValidation,
  emailValidationIfRequired,
} from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    name: null,
    advisor: null,
    advisorsExternalZone: [],
    city: null,
    state: null,
    zipCode: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("user", ["distributorSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("zone", ["add"]),
    validation(name) {
      return requiredValidation(name);
    },
    validationEmail(name) {
      return emailValidationIfRequired(name);
    },
    async addZone() {
      try {
        if (this.$refs.addUser.validate()) {
          this.isLoading = true;
          let payload = {
            name: this.name,
            city: this.city || "",
            state: this.state || "",
            distributor: this.distributorSelected._id,
            advisors: this.advisorsExternalZone, // internal solena advisors assigned to a personalized area of the client
            zipCode: this.zipCode || "",
          };
          let response = await this.add(payload);
          if (!response) throw response;
          this.$emit("fetchData");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Zona creado",
            timeout: 5000,
          });
          this.show = false;
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al crear usuario",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
    removeAdvisor(index) {
      this.advisorsExternalZone.splice(index, 1);
    },
    validationEmailPattern(email) {
      return /^$|^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(email);
    },
    addAdvisor() {
      if (!this.advisor) return;
      const email = this.advisor.trim();
      if (!this.validationEmailPattern(email)) {
        return;
      }
      this.advisorsExternalZone.push(this.advisor);
      this.advisor = null;
    },
  },
};
</script>
